import MusicianPage from './Pages/MusicianPage/musicianPage'
import LandingPage from './Pages/LandingPage/landingPage'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import Login from './Pages/LoginPage/loginPage'
import Layout from './Pages/Layout'
import { ThemeProvider } from '@mui/material'
import theme from './Theme/theme'
import RedirectPage from './Pages/RedirectPage/redirectPage'
import ChoosePage from './Pages/ChoosePage/choosePage'
import SearchPage from './Pages/SearchPage/searchPage'
import VerifyEmailPage from './Pages/VerifyEmailPage/verifyEmailPage'
import EmailVerifiedPage from './Pages/EmailVerifiedPage/emailVerifiedPage'

function App() {
  return (
    <div className="lg:h-full">
      <BrowserRouter>
        <Routes>
          <Route
            path="*"
            element={
              <ThemeProvider theme={theme}>
                <Layout>
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/redirect" element={<RedirectPage />} />
                    <Route path="/choose" element={<ChoosePage />} />
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/example-profile" element={<MusicianPage />} />
                    <Route path="/u/:uid" element={<MusicianPage />} />
                    <Route path="/search" element={<SearchPage />} />
                    <Route path="/verify-email" element={<VerifyEmailPage />} />
                    <Route path="/email-verified" element={<EmailVerifiedPage />} />
                  </Routes>
                </Layout>
              </ThemeProvider>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App
